<script>
export default {
  functional: true,
  props: {
    selectView: Function,
    value: String,
    hasList: {
      type: Boolean,
      default: false,
    },
    hasDetail: {
      type: Boolean,
      default: false,
    },
    hasCard: {
      type: Boolean,
      default: false,
    },
    hasMap: {
      type: Boolean,
      default: false,
    },
    hasRelations: {
      type: Boolean,
      default: false,
    },
    hasEdit: {
      type: Boolean,
      default: false,
    },
    hasPie: {
      type: Boolean,
      default: false,
    },
    hasLine: {
      type: Boolean,
      default: false,
    },
  },
  render: (h, { props }) => {
    const {
      selectView,
      value,
      hasMap,
      hasRelations,
      hasEdit,
      hasList,
      hasCard,
      hasDetail,
      hasPie,
      hasLine,
    } = props
    const doSelect = value => { selectView(value) }

    let mapBtn = hasMap
      ? (<v-btn flat value="map">
        <v-icon>map</v-icon>
      </v-btn>)
      : ''
    let relBtn = hasRelations
      ? <v-btn flat value="relation">
        <v-icon>device_hub</v-icon>
      </v-btn>
      : null
    let editBtn = hasEdit
      ? <v-btn flat value="edit">
        <v-icon>edit</v-icon>
      </v-btn>
      : null
    let listBtn = hasList
      ? <v-btn flat value="table">
        <v-icon>view_column</v-icon>
      </v-btn>
      : null
    let cardBtn = hasCard
      ? <v-btn flat value="card">
        <v-icon>view_module</v-icon>
      </v-btn>
      : null
    let detailBtn = hasDetail
      ? <v-btn flat value="detail">
        <v-icon>description</v-icon>
      </v-btn>
      : null
    let pieBtn = hasPie
      ? <v-btn flat value="pie">
        <v-icon>pie_chart</v-icon>
      </v-btn>
      : null
    let lineBtn = hasLine
      ? <v-btn flat value="line">
        <v-icon>timeline</v-icon>
      </v-btn>
      : null

    return (
      <v-toolbar-items>
        <v-btn-toggle
          mandatory
          on-change={ doSelect }
          input-value={ value }
          class="view-selector"
        >
          { cardBtn }
          { listBtn }
          { detailBtn }
          { editBtn }
          { relBtn }
          { mapBtn }
          { pieBtn }
          { lineBtn }
        </v-btn-toggle>
      </v-toolbar-items>
    )
  },
}
</script>

<style scoped>
.v-btn-toggle.view-selector {
  background: transparent;
}
</style>
